export default __webpack_public_path__ + "static/media/spiner.613bf596.svg";